interface IAddEditTimeRequestProps {
    time: Date | null;
    elapsedTime?: number | null;
    startingTime?: Date | null;
    raceContestantId?: number | null;
    bib?: number | null;
    stationId?: number | null;
    tuid?: string | null;
    forceFinish?: boolean;
    forcedLap?: number;
}

export class AddEditTimeRequest {
    /**
     * The elapsed time in milliseconds.
     * This is the time from the start
     * Changing this will change the Time and it is always the Time that is stored in the database
     */
    elapsedTime: number | null;

    /**
     * The actual starting time.
     * In order to calculate the actual ElapsedTime we need to know the starting time
     * If not provided the ElapsedTime box will not be visible
     */
    startingTime: Date | null;

    /**
     * The actual clock time for the pass
     */
    time: Date | null;

    /**
     * The ID of the race contestant
     * If we have this we do not need to show the bib number
     */
    raceContestantId: number | null;

    /**
     * The Bib number of the contestant
     */
    bib: number | null;

    /**
     * The ID of the passing station
     * If not provided you will have to select it
     */
    stationId: number | null;

    /**
     * The TUID of the transaction. If this one is provided we assume we are editing the time i.e we DISABLE the previous time and add a new one
     */
    tuid: string | null;

    /**
     * If this is set to true, the time will be forced to be the finish time, even if there are mandatory passes. This will be the actual time of the race
     */
    forceFinish: boolean = false;

    /**
     * If set, the forceFinish will be for a given lap and not the end of the race
     * @remarks This only work if forceFinish is set to true
     */
    forcedLap: number | null = null;

    constructor(params: IAddEditTimeRequestProps) {
        this.elapsedTime = params.elapsedTime ?? null;
        this.startingTime = params.startingTime ?? null;
        this.time = params.time ?? null;
        this.raceContestantId = params.raceContestantId ?? null;
        this.bib = params.bib ?? null;
        this.stationId = params.stationId ?? null;
        this.tuid = params.tuid ?? null;
        this.forceFinish = params.forceFinish ?? false;
        this.forcedLap = params.forcedLap ?? null;
    }
}
